import api from "../Config/api";

export const getAllVehicles = async () => {
  const response = await api.get("/vehicle/");
  return response.data;
};

export const getVehicleById = async (id) => {
  const response = await api.get(`/vehicle/?id=${id}`);
  return response.data;
};

export const getVehiclesByVendorId = async (vendorId) => {
  const response = await api.get(`/vehicle/?vendor_id=${vendorId}`);
  return response.data;
};

export const saveVehicle = async (data) => {
  const response = await api.post("/vehicle/", data, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

export const deleteVehicle = async (id) => {
  const response = await api.delete(`/vehicle/?id=${id}`);
  return response.data;
};
